import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Home.module.css';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const WalletBanner = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.cashback} ${styles.sr}`} data-sr>
        <div className={styles.cbGrid}>
          <div>
            <span className={styles.eyebrow}><span className={styles.dot} />Fyntiq Wallet</span>
            <h2>Let customers pay with Fyntiq Wallet.</h2>
            <p>Add Fyntiq Wallet to your checkout and let customers pay in seconds with the balance they already carry across the Fyntiq network — fast, secure, and built in with no extra setup.</p>
            <div className={styles.walletCta}>
              <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow} style={{ color: '#161614' }}>Accept Fyntiq Wallet</Link>
              <a href="https://wallet.fyntiq.com" className={styles.walletLink} target="_blank" rel="noopener noreferrer">Learn more about Fyntiq Wallet →</a>
            </div>
          </div>
          <div className={styles.cbVisual}>
            <div className={styles.cbChip}><span className={styles.cbLabel}>Checkout speed</span><span className={styles.cbValue}>Seconds</span></div>
            <div className={styles.cbChip}><span className={styles.cbLabel}>Security</span><span className={styles.cbValue}>256-bit</span></div>
            <div className={styles.cbChip}><span className={styles.cbLabel}>Where it works</span><span className={styles.cbValue}>Network</span></div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WalletBanner;
